import "./EmptyState.css";

function EmptyState({
  icon,
  title,
  description,
  buttonText,
  onButtonClick,
}) {
  return (
    <div className="empty-state">

      <div className="empty-icon">
        {icon}
      </div>

      <h2>{title}</h2>

      <p>{description}</p>

      <button onClick={onButtonClick}>
        {buttonText}
      </button>

    </div>
  );
}

export default EmptyState;